import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Optional
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';
import { environment } from 'src/environments/environment.prod';
import { JwtService } from 'src/_lib/service/jwt.service';
import { LoginService } from 'src/_lib/service/login.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { HeaderService } from 'src/_lib/service/header.service';
import { AppConstants } from 'src/app/app.constants';
import { CryptoService } from 'src/_lib/service/crypto.service';
import { MatButtonModule } from '@angular/material/button';
import { SubscribeComponent } from 'src/app/templates/subscribe/subscribe.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CommonModule, NgIf, NgStyle, NgClass } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';
import { CustomerLoginService } from 'src/_lib/service/customer-login.service';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { BrowserService } from 'src/_lib/service/browser.service';


declare const google: any;
declare const FB: any;
declare global {
  interface Window {
    fbAsyncInit: () => void;
  }
}

@Component({
  selector: 'app-customer-login',
  templateUrl: './customer-login.component.html',
  styleUrls: ['./customer-login.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgStyle,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    RouterLink,
    SubscribeComponent,
    MatButtonModule,
    CommonModule,
    ShopByVehicleComponent,
    NgClass
  ]
})
export class CustomerLoginComponent implements OnInit, OnDestroy {
  firstObj: number = this.appConstants.firstObj;
  loginForm: FormGroup;
  isSubmitClicked: boolean = false;
  clientid: string = environment.client_id;
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  page: string;
  loginPageImage: string;
  cartItems: number;
  totalItems: number = 0
  loginError = false;
  rememberMe = false;
  isLogin: number = 1;
 isSearchByVehicleDisabled: boolean = false;
  chTheme4: boolean = environment.chTheme4;
  chTheme5 = environment.chTheme5;
  closeIcon: string = environment.closeIcon;
  showSocialMediaOnLogin:boolean=environment.showSocialMediaOnLogin;
  @HostBinding('class.no-scroll') noScroll = false;

  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private jwtService: JwtService,
    private dialog: MatDialog,
    @Optional() private dialogRef: MatDialogRef<CustomerLoginComponent>,
    private headerHttp: HeaderService,
    private comm: CommunicationService,
    private commonPageServie: CommanpageService,
    private appConstants: AppConstants,
    private passEncrpt: CryptoService,
    private cdRef: ChangeDetectorRef,
    private cookieService: CookieService,
    private browser: BrowserService,
    private customerLogin: CustomerLoginService
  ) { }

  ngOnInit(): void {
    // Everything below is browser-only — skip on SSR.
    if (!this.browser.isBrowser) {
      return;
    }
   const vehicleBtnData = this.commonPageServie.isSearchByVehicleDisabled();
    this.isSearchByVehicleDisabled = vehicleBtnData?.viewAll;
    this.noScroll = true;
    this.totalItems = +this.browser.localStorage?.getItem('ItemCount') || null;
    this.initializeGoogleSignIn();
    this.initializeFacebookSdk();
    this.loadLoginImage();
    this.page = this.browser.localStorage?.hasOwnProperty('page')
      ? this.browser.localStorage?.getItem('page')
      : 'customer-login-page';
    this.loginForm = this.fb.group({
      email_address: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      password: ['', [Validators.required, Validators.minLength(6)]],
      rememberMe: [false],
    });
    this.loadRememberedEmail();
    const token = this.jwtService.getTokenFromLocalStorage();
    if (token) {
      this.customerLogin.redirectAfterLogin();
      return;
    }
  }

  loadRememberedEmail(): void {
    const savedEmail = this.cookieService.get('rememberMeEmail');
    if (savedEmail && savedEmail.trim() !== '') {
      this.loginForm.patchValue({
        email_address: savedEmail,
        rememberMe: true,
      });
    } else {
      this.loginForm.patchValue({
        email_address: '',
        rememberMe: false,
      });
    }
  }

  loadLoginImage(): void {
    this.headerHttp.headerList().subscribe((response) => {
      if (response) {
        this.loginPageImage =
          response[this.firstObj].data?.loginBackgroundImage[
            this.firstObj
          ].large_file;
      } else {
        console.warn('No header data found in localStorage');
      }
    });
  }

  initializeGoogleSignIn() {
    if (typeof document !== 'undefined') {
    const script = document.createElement('script') as HTMLScriptElement;
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      google.accounts.id.initialize({
        client_id: this.clientid,
        callback: this.handleCredentialResponse.bind(this),
      });
      google.accounts.id.renderButton(
        document.getElementById('googleSignInButton') || document.getElementById('googleSignInButtonmain'),
        { theme: 'outline', size: 'large' }
      );
    };
    document.head.appendChild(script);
  }
  }

  decodeJWTToken(token: string) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      throw new Error('Invalid token format');
    }
  }

  sendUserDataToBackend(user: any) {
    this.loginService.SocialLogin(user).subscribe({
      next: async(response: any) => {
        if (response && response[this.firstObj]?.data.token) {
          this.browser.localStorage?.setItem('UserToken', response[this.firstObj]?.data.token);
          this.browser.localStorage?.setItem('CustomerKey', response[this.firstObj]?.data.customer_info.customer_key);
          this.loginService.setUserLoggedIn(true);
          await this.customerLogin.handleOrderAndRedirect();
          this.customerLogin.loadWishlistItems();
          if (this.router.url !== '/cart') {
            this.customerLogin.loadCartProducts();
          } 
          if(this.page != 'customer-login-page') this.dialogRef.close(true);
        } else {
          console.error('Token not found in API response');
        }
      },
      error: (error) => {
        console.error('API Error: ', error);
      },
    });
  }

  initializeFacebookSdk() {
    if (!this.browser.isBrowser || !this.browser.window) {
      return;
    }
    this.browser.window.fbAsyncInit = () => {
      FB.init({
        appId: '24975702688720442',
        cookie: true,
        xfbml: true,
        version: 'v18.0',
      });
      FB.AppEvents.logPageView();
    };
    (function (d, s, id) {
      let js: HTMLScriptElement;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  handleCredentialResponse(response: any) {
    this.processToken(response.credential, 'gmail');
  }

  handleFacebookLoginResponse(response: any) {
    if (response?.authResponse) {
      const accessToken = response?.authResponse.accessToken;
      FB.api(
        '/me',
        { fields: 'first_name,last_name,email' },
        (userData: any) => {
          const user = {
            first_name: userData?.first_name,
            type: 'facebook',
            facebook_token: accessToken,
          };
          this.browser.localStorage?.setItem('Username', user?.first_name);
          this.comm.setUsername(user?.first_name);
          this.comm.usernameSubject.next(true);
          this.loginService.setUserLoggedIn(true);
          this.sendUserDataToBackend(user);
          if (userData?.email) {
            this.cookieService.set('rememberMeEmail', userData.email, 7);
            this.loginForm.patchValue({
              email_address: userData.email,
              rememberMe: true,
            });
          }
        }
      );
    } else {
      console.error('User cancelled login or did not fully authorize.');
    }
  }

  processToken(token: string, type: string) {
    const userData = this.decodeJWTToken(token);
    const user = {
      first_name: userData.given_name,
      gmail_token: token,
      type: type,
    };
    this.loginService.SocialLogin(user).subscribe({
      next: (response: any) => {
        if (response[this.firstObj].data?.success == true) {
          this.browser.localStorage?.setItem('Username', user.first_name);
          this.comm.setUsername(user.first_name);
          this.comm.usernameSubject.next(true);
          this.loginService.setUserLoggedIn(true);
          this.sendUserDataToBackend(user);
          if (userData.email) {
            this.cookieService.set('rememberMeEmail', userData.email, 7);
            this.loginForm.patchValue({
              email_address: userData.email,
              rememberMe: true,
            });
          }
        } else {
          console.error('Token not found in API response');
        }
      },
      error: (error) => {
        console.error('API Error: ', error);
      },
    });
  }

  async getLoginForm() {
    this.isSubmitClicked = true;
    this.loginError = false;
    if (this.loginForm.valid) {
      const password = this.loginForm.controls['password'].value;
      this.loginForm.controls['password'].setValue(
        this.passEncrpt.encrypt(password)
      );
      const userData = this.loginForm.value;
      this.isLogin = await this.customerLogin.getCustomerLogin(userData);
      this.cdRef.detectChanges();
      if (this.isLogin == 0) {
        if(this.page != 'customer-login-page') this.dialogRef.close(true);
        this.loginError = false;
      } else if (this.isLogin == 1) {
        this.showLoginError();
      }
      const email_address = this.loginForm.value.email_address;
      const rememberMe = this.loginForm.value.rememberMe;
      if (rememberMe) {
        this.cookieService.set('rememberMeEmail', email_address, 7);
      } else {
        this.cookieService.delete('rememberMeEmail');
      }
    }
  }

  showLoginError() {
    this.loginError = true;
    setTimeout(() => {
      this.loginError = false;
    }, 2000);
  }

  loginWithFacebook() {
    FB.login((response: any) => this.handleFacebookLoginResponse(response), {
      scope: 'public_profile,email',
    });
  }

  showGeneralLoginPopup(): void {
    this.browser.localStorage?.removeItem('page');
    this.router.navigate(['/customer-login']);
    this.comm.closedDialog$.next(true);
  }

  closePopup() {
    this.browser.localStorage?.removeItem('page');
    this.comm.closedDialog$.next(true);
    this.dialogRef.close(false);
  }

  redirectToForgotLink() {
    this.router.navigate(['/forget-password']);
    this.closePopup();
  }

  redirectToSignupLink() {
    this.router.navigate(['/sign-up']);
    this.closePopup();
  }

  ngAfterViewInit(): void {
    // @HostBinding('class.no-scroll') must not be set during ngOnInit because
    // SSR renders the host element without the class, but the client would add it
    // immediately — causing a hydration mismatch on the host node's class attribute.
    // AfterViewInit runs after hydration is complete, so setting it here is safe.
    if (this.browser.isBrowser) {
      this.noScroll = true;
    }
  }

  ngOnDestroy(): void {
    this.noScroll = false;
  }
}